import {ApiSlice} from "@/store/ApiSlice";
import RESTAPIConfig from "@/config/RESTAPIConfig";

const restApiConfig = new RESTAPIConfig();

export interface GetMyPermissionsResponseInterface {
    data: { alias: string }[]
}

export const GetMyPermissionsApiSlice = ApiSlice.injectEndpoints({
    endpoints: builder => ({
        getMyPermissions: builder.query<string[], void>({
            query: () => ({
                url: restApiConfig.baseUrl + restApiConfig.apiPrefixV2 + restApiConfig.myPermissions(),
            }),
            transformResponse: (result: GetMyPermissionsResponseInterface) => {
                return result.data.map((item) => item.alias);
            },
            providesTags: ["FetchedData", "MyPermissions"],
        })
    })
});

export const {useGetMyPermissionsQuery} = GetMyPermissionsApiSlice;
